<template>
  <div class="pageElement">
    <ul>
      <li
        class="title-nav"
        v-for="(item, index) in menuDatas"
        :key="index"
        :class="index === onIndex ? 'active' : ''"
        v-track="[ item.name, '文字点击' ]"
      >
        <router-link @click.native="update(item)" :to="item && item.routerName !== null ? `${item.routerName}` : `/detail`">
        <span class="no-detail">{{ item.name }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { Categories } from "../../../../gqlapi/Categories.js"

export default {
  name: "pageElement",
  props: {
    onIndex: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data () {
    return {
      menuDatas: []
    }
  },
  created () {
    this.getNavData()
  },
  methods: {
    update (item) {
      this.$store.commit("updateToggleImg", false)
      window.sessionStorage.setItem("subjectID", String(item.id))
    },
    getNavData () {
      // this.$apollo.query(
      //   {
      //     query: Categories,
      //     variables: {
      //       isPublish: true
      //     }
      //   })
        this.$axios.post('/api',{
            operationName: "Categories",
            variables:{
                isPublish: true,
            },
            query: Categories
        })
        .then((res) => {
          this.menuDatas = res.data.pCategories.slice(0, 8)
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .pageElement {
    display: none;
    width: 1200px;
    margin: 0 auto;
    ul {
      display: flex;
      justify-content: space-around;
      margin-top: 24px;
      .title-nav {
        height: 32px;
        border-radius: 20px;
        background-color: white;
        cursor: pointer;
        &:hover {
          color: #1286FF;
        }
        a {
          border-radius: 20px;
          line-height: 32px;
          width: 100%;
          padding: 7px 35px;
          box-sizing: border-box;
          .no-detail {

          }
          .detail {
            .dataNum {
              padding-left: 10px;
            }
          }
        }
      }
      .active {
        background: #1286FF;
        color: #f9f9f9 !important;
        a {
          color: #f9f9f9 !important;
        }
      }
    }
  }
</style>